import { render } from "./EasyNav.vue?vue&type=template&id=838931de"
import script from "./EasyNav.vue?vue&type=script&lang=js"
export * from "./EasyNav.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__